import { ExchangeDispatch } from '../../../../../core';
import { inStorePickingDetail } from '../../../data-table/data-table-config';

const iconsOfActionsList = inStorePickingDetail.iconsOfActions.filter(item => !item.icon.includes('printer'));

export const exchangeManagementDetail = {
  searchText: 'Buscar orden',
  expandable: true,
  expandableType: 'ProductCard',
  checkbox: false,
  detailQuantity: true,
  actionIcons: iconsOfActionsList,
  items: [
    {
      title: 'N° de Pedido',
      name: 'orderNumber',
      class: 'col-12',
      icon: 'photo',
      value: (element: ExchangeDispatch) => element.dispatchNumber
    },
    {
      title: 'Cliente',
      name: 'customer',
      class: 'col-8',
      value: (element: ExchangeDispatch) => element.customerName
    },
    {
      title: 'N° de doc.',
      name: 'customerDocumentNumber',
      class: 'col-4',
      value: (element: ExchangeDispatch) => element.customerDocumentNumber
    },
    {
      title: 'Fecha de Entrega',
      name: 'retireDate',
      onFooter: true,
      value: (element: ExchangeDispatch) => element.deliveryDate
    }
  ]
};
